import axios from "axios";
import router from "@/router";
import { useAuthStore } from "@/stores/admin/authStore";

const apiUrl = process.env.VUE_APP_API_URL
if (!apiUrl) {
  console.error('[SISGEL] VUE_APP_API_URL nao configurada. Usando localhost como fallback de desenvolvimento.')
}

const api = axios.create({
  baseURL: apiUrl || 'http://localhost:8080/sisgel/api/v1',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true
});

// Request interceptor - attach token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor
// - Sucesso: unwrap SisgelApiResponse { status, mensagem, data } -> retorna data direto
// - Erro: extrai mensagem do ErrorResponse { status, erro, mensagem } -> reject com mensagem
const REDIRECT_COOLDOWN_MS = 2000
let isRedirecting = false

api.interceptors.response.use(
  (response) => {
    const body = response.data

    // Se o response for blob/arraybuffer (download), retorna sem modificar
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response
    }

    // Se o body tem a estrutura SisgelApiResponse (tem campo "data" e "status"/"mensagem")
    if (body && typeof body === 'object' && 'data' in body && ('status' in body || 'mensagem' in body)) {
      // Unwrap: retorna apenas o campo data interno
      response.data = body.data
    }

    return response
  },
  (error) => {
    // Handle 401 — sessao expirada, logout imediato
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/auth/login')
      if (!isLoginRequest && !isRedirecting) {
        isRedirecting = true
        try {
          const authStore = useAuthStore()
          authStore.logout()
        } catch {
          sessionStorage.clear()
          delete api.defaults.headers.common['Authorization']
        }
        router.push({ name: 'Login' })
        setTimeout(() => { isRedirecting = false }, REDIRECT_COOLDOWN_MS)
      }
    }

    // Enrich error with mensagem from ErrorResponse
    if (error.response?.data) {
      const errData = error.response.data
      error.mensagem = errData.mensagem || errData.erro || errData.message || 'Erro desconhecido'
      error.campos = errData.campos
    }

    return Promise.reject(error)
  }
)

export default api;
